<template>
  <div class="LiveTalk">
    <div class="tracking-wider min-h-50 border borderColordarkgray2 rounded overflow-hidden px-4 md:px-8 py-6 md:py-8">
      <h3 class="text-NotoSansBold text-base lg:text-lg title mb-3 lg:mb-5 px-2 md:text-center">LiveTalk網際網路服務契約</h3>
      <div class="text-NotoSansRegular">
        <div class="revise-title mb-6 leading-loose">
          <h5>立契約書人</h5>
          <h5>甲方：線上購買LiveTalk之消費者（以下簡稱「甲方」）</h5>
          <h5>乙方：希伯崙股份有限公司（以下簡稱「乙方」）</h5>
          <h5>負責人：鄭俊琪</h5>
        </div>
        <div class="revise-body text-NotoSansRegular text-sm">
          <div v-for="(item, index) in contract" :key="index" class="mb-8">
            <h5 class="font-bold">{{ item.title }}</h5>
            <ul class="list-none list-inside mt-4 ml-2"  v-if="item.detail">
              <li v-for="(child, idx) in item.detail" :key="idx">{{ child.text }}
                <ul class="list-inside mt-4 ml-2" v-if="child.textDetail">
                  <li v-for="(children, idx) in child.textDetail" :key="idx">{{ children.text }}</li>
                </ul>
              </li>
            </ul>
            <h5 v-if="item.thirdTitle">{{ item.thirdTitle }}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveTalk',
  metaInfo () {
    return {
      title: 'LiveTalk網際網路服務契約',
      titleTemplate: null
    }
  },
  data () {
    return {
      contract: [
        {
          title: '第一條（本服務之定義）',
          detail: [
            { text: '乙方授權甲方利用網際網路連線方式，於乙方指定網站系統，使用乙方提供之「LiveTalk線上真人口說教室及其他相關服務」（以下簡稱「本服務」）' }
          ]
        },
        {
          title: '第二條（本服務內容）',
          secondTitle: '本服務內容包括以下各款：',
          detail: [
            { text: '乙方提供本服務之網站網址：https://livetalk.liveabc.com/' },
            { text: '乙方提供本服務之對象：對提升英語聽說口語能力有需求與興趣者。' },
            { text: '乙方提供本服務之內容：乙方於線上教授甲方英語聽說讀寫課程，為一對一或一對多線上真人家教，甲方可依實際需求選擇課程。' },
            { text: '乙方提供本服務之功能：',
              textDetail: [
                { text: '預約課程：甲方於上課前，先於乙方開發及營運之LiveTalk網站預約適合程度之課程。' },
                { text: '線上授課：依據乙方研發之授課教材教授甲方英語聽說讀寫課程。' },
                { text: '課程顧問：乙方依照甲方之個別學習狀況提出學習計劃，提供課程顧問之服務。' }
              ]
            },
            { text: '乙方提供之本服務教學課程數量如下，各等級各別銷售，甲方可視實際需求訂購：',
              textDetail: [
                { text: 'LiveTalk 30點新台幣4500元，於點數開通後一年內有效。' }
              ]
            }
          ]
        },
        {
          title: '第三條（設備規格）',
          detail: [
            { text: '甲方硬體需求：',
              textDetail: [
                { text: '最低配備：CPU Pentium 4以上、記憶體1GB以上、硬碟剩餘空間1GB以上。' },
                { text: '網路設備：ADSL或是CableModem或任何Intertnet專線。' },
                { text: '螢幕解析度：1024*768顯示能力之顯示卡及顯示器。' }
              ]
            },
            { text: '甲方軟體需求：',
              textDetail: [
                { text: '視訊軟體：TeamViewer及Zoom軟體。' },
                { text: '網頁瀏覽器：Google Chrome。' },
                { text: '甲方連線需求：下載速度8 Mbps以上之寬頻網路。' }
              ]
            }
          ],
          thirdTitle: '以上設備規格為線上使用本服務之最低需求建議，惟乙方無法保證甲方實際使用操作上之狀況，如有使用上的問題，甲方應通知乙方尋求協助。'
        },
        {
          title: '第四條（本契約之成立）',
          detail: [
            { text: '甲方經由網際網路購買本服務者，於乙方所指定網頁上點選「同意」鍵後，視為同意購買本服務，本契約即成立。' }
          ]
        },
        {
          title: '第五條（服務序號密碼）',
          detail: [
            { text: '甲方於線上完成付款程序後，乙方應於三至五個工作天內提供本服務之「序號啟用及密碼通知信」（內含一組序號及登入密碼）至甲方登記之電子郵件信箱。' }
          ]
        },
        {
          title: '第六條（使用權之取得）',
          detail: [
            { text: '甲方於收受前條通知之日起，取得本服務之使用權。' }
          ]
        },
        {
          title: '第七條（使用權之限制）',
          detail: [
            { text: '乙方授權甲方依本契約之約定，對於本服務享有非專屬之使用權。' },
            { text: '未經乙方事前之書面同意，甲方不得將其使用權轉讓第三人或再授權第三人使用。' }
          ]
        },
        {
          title: '第八條（七天猶豫期之排除說明）',
          detail: [
            { text: '甲方瞭解並同意本服務屬「通訊交易解除權合理例外情事適用準則」所定之「非以有形媒介提供之數位內容或一經提供即為完成之線上服務」，得排除消費者保護法第十九條規定七天猶豫期之適用。' }
          ]
        },
        {
          title: '第九條（授權期間或使用權利）',
          detail: [
            { text: '乙方授權甲方使用本服務之期間、次數或權利依下列之約定：',
              textDetail: [
                { text: '甲方於收受本服務之服務序號及密碼，取得本服務使用權之次日起，為期一年之使用期間。甲方於取得本服務使用權後，不得對授權期間長短為異議，或要求延長或暫停。' }
              ]
            }
          ]
        },
        {
          title: '第十條（授權使用規則）',
          detail: [
            { text: '甲方有下列情形之一者，由甲方自負一切法律責任，乙方並得通知甲方終止本契約，甲方不得拒絕：',
              textDetail: [
                { text: '甲方蓄意散佈干擾乙方網路系統正常運作之電腦程式。' },
                { text: '甲方在乙方網路系統上散佈恐嚇、毀謗、侵犯他人隱私、色情或其他違反公序良俗之文字、圖片或影像。' }
              ]
            },
            { text: '甲方利用本服務從事其他不法或違反本契約約定事項之行為，其情節重大，且經乙方通知甲方限期改正而未改正者，乙方亦得通知甲方終止本契約，甲方不得拒絕。' },
            { text: '乙方依前二項約定終止本契約時，甲方不得向乙方主張一部或全部退費。' }
          ]
        },
        {
          title: '第十一條（甲方之責任）',
          detail: [
            { text: '甲方依第四條點選「同意」鍵，進入付費流程後，即有繳納授權使用費用之義務。' },
            { text: '甲方應妥善保管其服務序號與密碼，避免洩漏。如因甲方怠於保密而致其服務序號與密碼外洩者，應由甲方自行負責。' },
            { text: '甲方依本契約第六條之約定所取得之服務序號與密碼如有錯誤或無法使用時，甲方應通知乙方請求更正。' }
          ]
        },
        {
          title: '第十二條（帳號密碼非法使用之處理）',
          detail: [
            { text: '利用甲方之使用者帳號與個人密碼，登入本服務電腦系統之行為，推定為甲方之行為。' },
            { text: '如任何一方發現甲方之使用者帳號或個人密碼，遭第三人非法使用，應立即通知對方，經甲方確認有遭第三人非法使用之情事，乙方應立即暫停該使用者帳號或個人密碼之使用，並接受甲方更換其使用者帳號或個人密碼。' },
            { text: '前項情形，如甲方能證明係非因可歸責於甲方之事由，致其使用者帳號或個人密碼遭第三人非法使用，得請求乙方延長相當甲方遭非法使用期間做為補償。' }
          ]
        },
        {
          title: '第十三條（智慧財產權）',
          detail: [
            { text: '甲方應尊重與本服務有關之所有智慧財產權，非經乙方及智慧財產權人事前書面同意，甲方不得以本契約授權以外之其他方式加以利用。' },
            { text: '甲方違反前項之約定者，乙方得終止契約，甲方不得請求退還費用，並應賠償乙方及智慧財產權人因此所受之損害。' }
          ]
        },
        {
          title: '第十四條（乙方保密義務）',
          detail: [
            { text: '乙方因提供本服務而知悉或持有甲方之學習紀錄或其他個人資料，除本契約另有約定外，乙方負有保密義務，除甲方請求查詢或第三人依據個人資料保護相關法令請求查詢者外，乙方不得對任何第三人揭露。' }
          ]
        },
        {
          title: '第十五條（乙方免責事由）',
          detail: [
            { text: '除本契約或乙方之廣告另有保證使用本服務之學習成效外，乙方不保證甲方使用本服務之學習成效。' }
          ]
        },
        {
          title: '第十六條（暫停服務之處理）',
          detail: [
            { text: '乙方對於本服務相關軟硬體設備，進行營運上必要之搬遷、更換、升級、保養或維修時，得暫停本服務之全部或一部。' },
            { text: '乙方因前項事由而暫停本服務之全部或一部，乙方應於暫停本服務七日前，於本服務網站首頁及本服務進行中公告，並以電子郵件或書面通知甲方。但因天災、事變、無預警停電或主機不正常當機等突發事件所致者，不在此限。' },
            { text: '乙方於恢復本服務後，經甲方申請，得准以延長甲方相當於實際暫停服務期間之使用期間做為補償。' }
          ]
        },
        {
          title: '第十七條（個人資料之保護）',
          detail: [
            { text: '乙方對於甲方個人資料之蒐集、處理及利用，應取得甲方事前之書面同意，並依誠實及信用方法為之，不得逾越本契約目的之必要範圍，且應與蒐集之目的具有正當合理之關聯。' },
            { text: '乙方為維護甲方個人資料之正確，應依甲方之請求即時更正或補充之。甲方個人資料正確性有爭議者，乙方應即時停止該個人資料之處理及利用或採取其他保護措施。' },
            { text: '除法律另有規定者外，乙方不得將甲方個人資料為本契約目的必要範圍外之利用，並不得將甲方個人資料於乙方關係企業之不同法人間流通。' }
          ]
        },
        {
          title: '第十八條（契約之變更）',
          detail: [
            { text: '甲方不得變更本契約條款內容。' },
            { text: '乙方如變更本契約條款內容應以電子郵件通知甲方，甲方應於收受通知後三日內，表示是否同意，甲方如於三日內未為表示者，視為同意。' }
          ]
        },
        {
          title: '第十九條（終止契約）',
          detail: [
            { text: '甲方於使用期間屆滿時，本契約即告終止。' }
          ]
        },
        {
          title: '第二十條（不可抗力事件）',
          detail: [
            { text: '因不可抗力事件，致本契約無法履行者，乙方得終止本契約。本契約終止後，甲方得向乙方申請按比例返還終止契約前尚未使用之本服務授權使用費金額。' }
          ]
        },
        {
          title: '第二十一條（乙方之申訴）',
          detail: [
            { text: '甲方對於乙方所提供之本服務，得以書面、電話、電子郵件，或至乙方之營業處所，向乙方提出申訴，乙方應自接獲甲方申訴之日起十五日內妥適處理之。' }
          ]
        },
        {
          title: '第二十二條（準據法）',
          detail: [
            { text: '因本契約所生之一切爭議，適用中華民國法律。' }
          ]
        },
        {
          title: '第二十三條（契約之解釋）',
          detail: [
            { text: '本契約條款內容如有疑義時，乙方有解釋之權。' }
          ]
        },
        {
          title: '第二十四條（管轄法院）',
          detail: [
            { text: '因本契約所生之一切爭議，雙方同意以臺灣臺北地方法院為第一審管轄法院。' }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    list-style-type: cjk-ideographic;
    li {
      margin-bottom: 1rem;
    }
  }
</style>
